// The concentric multi-band agent dot. The option (a set of concentric shapes in a
// `0 0 64 64` viewBox, outer band edge-to-edge) is chosen from the shared 20-option
// system in common-lib (`agentDotShapes` / `optionForAgent`), keyed by the same
// avalanche hash on web and native — so an agent's dot reads identically everywhere.
//
// The old local 5-triplet `AGENT_TRIPLETS` / `tripletFor` was retired: geometry and
// color now live entirely in common-lib's `AGENT_OPTIONS`, matching iOS/Android 1:1.
// The shapes render as real SVG <ellipse> elements (a circle is rx === ry) — no
// raw-HTML injection.

import { agentDotShapes } from '@wix/ai-scheduling-assistant-common-lib/entities';

export function AgentDot({ id, size = 20, ringColor }: { id: string; size?: number; ringColor?: string }) {
  const shapes = agentDotShapes(id);
  return (
    <span
      style={{
        display: 'block',
        width: size,
        height: size,
        flexShrink: 0,
        borderRadius: '50%',
        boxShadow: ringColor ? `0 0 0 ${Math.max(1.5, size * 0.075)}px ${ringColor}` : undefined,
      }}
    >
      <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden style={{ display: 'block' }}>
        {shapes.map((s, i) => (
          <ellipse key={i} cx={s.cx} cy={s.cy} rx={s.rx} ry={s.ry} fill={s.fill} />
        ))}
      </svg>
    </span>
  );
}
